export default __webpack_public_path__ + "static/media/0F92E26B-0246-4384-AC91-B4D0D0173DE2.1b26130c.jpeg";